import { useQuery } from '@tanstack/react-query';
import { notesApi } from '@/api/notes';
import { queryKeys } from '@/query/queryKeys';

type Params = { calendarId?: string; from?: string; to?: string };

const useNotesQuery = (params: Params = {}, options: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: queryKeys.notes(params),
    queryFn: () => notesApi.list(params),
    enabled: options.enabled ?? true,
  });

export { useNotesQuery };
